export default __webpack_public_path__ + "static/media/ShxAIxEa.1caa7082.svg";